<form>
  <mat-form-field appearance="outline">
    <mat-label>کد تخفیف شما</mat-label>

    <input
      [disabled]="codeSelected"
      #vCode
      #voucherCodeInput
      [disabled]="codeSelected"
      [value]="selectedVoucher?.code"
      (change)="voucherChanged($event)"
      type="text"
      matInput
    />
    <button
      matSuffix
      mat-flat-button
      [disabled]="codeSelected"
      [color]="codeSelected ? 'accent' : 'primary'"
      (click)="checkCode(vCode.value)"
    >
      <jam-icon *ngIf="!codeSelected && !loading" name="search" />
      <jam-icon *ngIf="codeSelected && !loading" name="check" />
      <span>
        <mat-spinner diameter="36" color="accent" *ngIf="loading" />
      </span>
    </button>
  </mat-form-field>
</form>
